<template>
  <div class="availability-settings">
    <h1 class="settings-title">
      Availability
    </h1>
    <div
      class="settings-form">
      <h2 class="settings-subtitle">
        Operating Hours
      </h2>
      <b-form-group class="mb-2">
        <label class="settings-label">Timezone</label>
        <b-select
          v-model="timezone"
          :plain="true"
          :options="timezones"
          class="settings-select"/>
      </b-form-group>
      <div class="working-times mt-5">
        <b-form-group
          v-for="day in days"
          :key="day">
          <b-row class="align-items-center">
            <b-col sm="2">
              <label
                :class="{active: workingTimes[day].available}"
                class="settings-label mb-2 mb-sm-0">
                {{ day }}:
              </label>
            </b-col>
            <b-col sm="8">
              <b-row class="align-items-center text-sm-center">
                <b-col sm="5">
                  <b-select
                    v-model="workingTimes[day].from"
                    :plain="true"
                    :options="timeIntervals"
                    class="settings-select mb-2 mb-sm-0"/>
                </b-col>
                <b-col sm="2"><label class="settings-label mb-2 mb-sm-0">to</label></b-col>
                <b-col sm="5">
                  <b-select
                    v-model="workingTimes[day].to"
                    :plain="true"
                    :options="filterTimeIntervals(day)"
                    class="settings-select mb-2 mb-sm-0"/>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="2">
              <SwitchCheckbox
                :id="`${day}-available`"
                v-model="workingTimes[day].available"
                size="mini"
                class="float-sm-right mb-2 mb-sm-0"/>
            </b-col>
          </b-row>
          <span
            v-if="errors.has(`select-${day}-to`)"
            class="validation-error">{{ errors.first(`select-${day}-to`) }}</span>
        </b-form-group>
      </div>
      <div class="clearfix"/>
      <div
        v-if="settingsSaved"
        class="success-info">
        Operating hours have been successfully updated.
      </div>
      <div
        v-if="errorMessage"
        class="error-message">
        {{ errorMessage }}
      </div>
      <b-button
        :class="{loading: saving}"
        :disabled="saving"
        class="btn-round btn-save"
        @click="updateOperatingHours">
        <span v-if="!saving">Save</span>
        <div class="loader"><div class="loading-circle"/></div>
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import timezones from '@/helpers/lists/timezones';
import timeIntervals from '@/helpers/lists/timeIntervals';
import setValidationErrors from '@/helpers/validationErrors';
import SwitchCheckbox from '../../common/SwitchCheckbox';

export default {
  name: 'AvailabilitySettings',
  components: {
    SwitchCheckbox,
  },
  data() {
    return {
      timezones,
      timeIntervals,
      days: [
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
        'sunday',
      ],
      workingTimes: {
        monday: {},
        tuesday: {},
        wednesday: {},
        thursday: {},
        friday: {},
        saturday: {},
        sunday: {},
      },
      timezone: 'UTC',
      settingsSaved: false,
      saving: false,
      errorMessage: '',
      validationErrors: {},
    };
  },
  computed: {
    ...mapGetters({
      merchantSettings: 'merchant/settings',
      availabilities: 'merchant/availabilities',
      availabilityTimesUpdated: 'merchant/availabilityTimesUpdated',
      apiError: 'merchant/apiError',
    }),
  },
  watch: {
    merchantSettings(settings) {
      this.timezone = settings.timezone;
    },
    availabilities(availabilities) {
      availabilities.forEach((availability) => {
        this.workingTimes[availability.day] = {
          from: availability.from,
          to: availability.to,
          available: availability.available,
        };
      });
    },
    availabilityTimesUpdated(saved) {
      if (saved) {
        this.saving = false;
        this.settingsSaved = true;
        setTimeout(() => {
          this.settingsSaved = false;
        }, 3000);
      }
    },
    apiError(error) {
      this.saving = false;
      if (error.status === 422) {
        this.validationErrors = setValidationErrors(error.data.errors);
      } else {
        this.errorMessage = error.data.message;
      }
    },
  },
  mounted() {
    this.fetchSettings(this.$route.params.merchant_id);
    this.fetchAvailabilities(this.$route.params.merchant_id);
  },
  methods: {
    ...mapActions({
      fetchSettings: 'merchant/fetchSettings',
      fetchAvailabilities: 'merchant/fetchAvailabilities',
      updateAvailabilityTimes: 'merchant/updateAvailabilityTimes',
    }),
    filterTimeIntervals(day) {
      const filteredIntervals = this.$lodash.pickBy(this.timeIntervals, (intervalName, interval) => interval > this.workingTimes[day].from);

      if (!filteredIntervals[this.workingTimes[day].to]) {
        this.workingTimes[day].to = Object.keys(filteredIntervals)[0];
      }

      return filteredIntervals;
    },
    updateOperatingHours() {
      this.validationErrors = {};
      this.errorMessage = '';
      // this.$validator.validate().then((valid) => {
      //   if (valid) {
      // });
      this.saving = true;
      const payload = {
        merchant_id: this.$route.params.merchant_id,
        data: {
          timezone: this.timezone,
          availabilities: this.workingTimes,
        },
      };

      this.updateAvailabilityTimes(payload);
    },
  },
};
</script>
